export const itemsCategoryOptions = [
  {
    value: 1,
    label: "Raw Materials",
  },
  {
    value: 2,
    label: "Finished Good",
  },
  {
    value: 3,
    label: "Consumables",
  },
];

export const metricsUnitOptions = [
  { value: "BAG", label: "BAG", description: "Bag" },
  { value: "BAL", label: "BAL", description: "Bale" },
  { value: "BDL", label: "BDL", description: "Bundle" },
  { value: "BKL", label: "BKL", description: "Bucket" },
  { value: "BOU", label: "BOU", description: "Bouquet" },
  { value: "BOX", label: "BOX", description: "Box" },
  { value: "BTL", label: "BTL", description: "Bottle" },
  { value: "BUN", label: "BUN", description: "Bunch" },
  { value: "CAN", label: "CAN", description: "Can" },
  { value: "CBM", label: "CBM", description: "Cubic Meter" },
  { value: "CCM", label: "CCM", description: "Cubic Centimeter" },
  { value: "CMS", label: "CMS", description: "Centimeter" },
  { value: "CTN", label: "CTN", description: "Carton" },
  { value: "DOZ", label: "DOZ", description: "Dozen" },
  { value: "DRM", label: "DRM", description: "Drum" },
  { value: "GGR", label: "GGR", description: "Great Gross" },
  { value: "GMS", label: "GMS", description: "Grams" },
  { value: "GRS", label: "GRS", description: "Gross" },
  { value: "GYD", label: "GYD", description: "Gross Yard" },
  { value: "KGS", label: "KGS", description: "Kilograms" },
  { value: "KLR", label: "KLR", description: "Kiloliter" },
  { value: "KME", label: "KME", description: "Kilometer" },
  { value: "MLT", label: "MLT", description: "Milliliter" },
  { value: "MTR", label: "MTR", description: "Meter" },
  { value: "MTS", label: "MTS", description: "Metric Ton" },
  { value: "NOS", label: "NOS", description: "Numbers" },
  { value: "PAC", label: "PAC", description: "Pack" },
  { value: "PCS", label: "PCS", description: "Pieces" },
  { value: "PRS", label: "PRS", description: "Pairs" },
  { value: "QTL", label: "QTL", description: "Quintal" },
  { value: "ROL", label: "ROL", description: "Roll" },
  { value: "SET", label: "SET", description: "Set" },
  { value: "SQF", label: "SQF", description: "Square Feet" },
  { value: "SQM", label: "SQM", description: "Square Meter" },
  { value: "SQY", label: "SQY", description: "Square Yard" },
  { value: "TBS", label: "TBS", description: "Tablets" },
  { value: "TGM", label: "TGM", description: "Ten Gross" },
  { value: "THD", label: "THD", description: "Thousand" },
  { value: "TON", label: "TON", description: "Ton" },
  { value: "TUB", label: "TUB", description: "Tube" },
  { value: "UGS", label: "UGS", description: "US Gallons" },
  { value: "UNT", label: "UNT", description: "Units" },
  { value: "YDS", label: "YDS", description: "Yards" },
];

export const taxTypeOptions = [
  { value: 1, label: "Inclusive" },
  { value: 2, label: "Exclusive" },
];

export const taxOptions = [
  { value: 0, label: "0 %" },
  { value: 0.1, label: "0.1 %" },
  { value: 0.25, label: "0.25 %" },
  { value: 3, label: "3 %" },
  { value: 5, label: "5 %" },
  { value: 6, label: "6 %" },
  { value: 12, label: "12 %" },
  { value: 18, label: "18 %" },
  { value: 28, label: "28 %" },
];

export const getDatesDDMMYYYY = (startDate = null, endDate = null) => {
  let start, end;

  if (startDate && endDate) {
    start = new Date(startDate);
    end = new Date(endDate);
  } else {
    end = new Date();
    start = new Date();
    start.setMonth(start.getMonth() - 1);
  }

  // Normalize to start of day (IST safe)
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const dates = [];

  while (start <= end) {
    const day = String(start.getDate()).padStart(2, '0');
    const month = String(start.getMonth() + 1).padStart(2, '0');
    const year = start.getFullYear();

    dates.push(`${day}-${month}-${year}`);
    start.setDate(start.getDate() + 1);
  }

  return dates.reverse();
}


export const isValidJSON = (data: string) => {
  try {
    return JSON.parse(data);
  } catch (error) {
    return false;
  }
}

export const calculateTotalProductionCost = (node: any) => {
  let total = 0;
  if (node.finishedGood && node.finishedGood.cost) {
    total += Number(node.finishedGood.cost);
  }
  if (node.children && Array.isArray(node.children)) {
    for (const child of node.children) {
      total += calculateTotalProductionCost(child);
    }
  }
  return total;
}

export const numberToWords = (amount: any, currencyCode: string = 'INR') => {
  if (amount === null || amount === undefined || isNaN(amount)) return '';

  const cleanCurrency = (currencyCode || 'INR').toUpperCase();

  const ones = [
    '', 'One', 'Two', 'Three', 'Four', 'Five',
    'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen',
    'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];

  const tens = [
    '', '', 'Twenty', 'Thirty', 'Forty',
    'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  const convertTwoDigits = (num: number) => {
    if (num < 20) return ones[num];
    return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '');
  };

  const convertThreeDigits = (num: number) => {
    let result = '';
    if (num >= 100) {
      result += ones[Math.floor(num / 100)] + ' Hundred ';
      num %= 100;
    }
    if (num > 0) result += convertTwoDigits(num);
    return result.trim();
  };

  const convertIntegerPartIndian = (num: number) => {
    if (num === 0) return 'Zero';

    let result = '';
    const crore = Math.floor(num / 10000000);
    num %= 10000000;

    const lakh = Math.floor(num / 100000);
    num %= 100000;

    const thousand = Math.floor(num / 1000);
    num %= 1000;

    if (crore) result += convertThreeDigits(crore) + ' Crore ';
    if (lakh) result += convertThreeDigits(lakh) + ' Lakh ';
    if (thousand) result += convertThreeDigits(thousand) + ' Thousand ';
    if (num) result += convertThreeDigits(num);

    return result.trim();
  };

  const convertIntegerPartInternational = (num: number) => {
    if (num === 0) return 'Zero';

    let result = '';
    const billion = Math.floor(num / 1000000000);
    num %= 1000000000;

    const million = Math.floor(num / 1000000);
    num %= 1000000;

    const thousand = Math.floor(num / 1000);
    num %= 1000;

    if (billion) result += convertThreeDigits(billion) + ' Billion ';
    if (million) result += convertThreeDigits(million) + ' Million ';
    if (thousand) result += convertThreeDigits(thousand) + ' Thousand ';
    if (num) result += convertThreeDigits(num);

    return result.trim();
  };

  const currencyMap: Record<string, { major: string; minor: string }> = {
    INR: { major: 'Rupees', minor: 'Paise' },
    USD: { major: 'US Dollars', minor: 'Cents' },
    EUR: { major: 'Euros', minor: 'Cents' },
    GBP: { major: 'Pounds', minor: 'Pence' },
    AED: { major: 'Dirhams', minor: 'Fils' },
    CAD: { major: 'Canadian Dollars', minor: 'Cents' },
    AUD: { major: 'Australian Dollars', minor: 'Cents' },
    SGD: { major: 'Singapore Dollars', minor: 'Cents' },
    SAR: { major: 'Saudi Riyals', minor: 'Halalas' },
    QAR: { major: 'Qatari Riyals', minor: 'Dirhams' },
    OMR: { major: 'Omani Rials', minor: 'Baisa' },
    KWD: { major: 'Kuwaiti Dinars', minor: 'Fils' },
    BHD: { major: 'Bahraini Dinars', minor: 'Fils' },
  };

  const currency = currencyMap[cleanCurrency] || { major: cleanCurrency, minor: 'Cents' };

  // 🔒 Force exactly 2 decimal places
  const fixedAmount = Number(amount).toFixed(2);
  const [integerPart, decimalPart] = fixedAmount.split('.');

  const integerVal = Number(integerPart);
  let words = '';

  if (cleanCurrency === 'INR') {
    words = convertIntegerPartIndian(integerVal) + ' ' + currency.major;
  } else {
    words = convertIntegerPartInternational(integerVal) + ' ' + currency.major;
  }

  // ✅ Correct decimal handling (01 → Zero One)
  const decimalNum = Number(decimalPart);
  if (decimalNum > 0) {
    const paiseWords =
      decimalNum < 10
        ? 'Zero ' + ones[decimalNum]
        : convertTwoDigits(decimalNum);

    words += ' and ' + paiseWords + ' ' + currency.minor;
  }

  return words + ' Only';
};

export const getFields = (dataToPreview: any) => {
  return [
    { label: "IRN Number", value: dataToPreview?.irnNumber },
    { label: "RFQ Number", value: dataToPreview?.rfqNumber || dataToPreview?.rfq_number },
    { label: "Purchase Request Number", value: dataToPreview?.indent_number },
    {
      label: "Purchase Request Date",
      value: dataToPreview?.indent_date
        ? new Date(dataToPreview.indent_date).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Quotation Number", value: dataToPreview?.quotationNumber },
    {
      label: "Quotation Date",
      value: dataToPreview?.quotationDate
        ? new Date(dataToPreview.quotationDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Purchase Order Number", value: dataToPreview?.purchaseOrderNumber },
    {
      label: "Purchase Order Date",
      value: dataToPreview?.purchaseOrderDate
        ? new Date(dataToPreview.purchaseOrderDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "GRN Number", value: dataToPreview?.grn_number },
    {
      label: "GRN Date",
      value: dataToPreview?.grn_Date
        ? new Date(dataToPreview.grn_Date).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Debit Note Number", value: dataToPreview?.debit_note_number },
    {
      label: "Debit Note Date",
      value: dataToPreview?.debit_note_date
        ? new Date(dataToPreview.debit_note_date).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Sales Lead", value: dataToPreview?.enquiryNumber },
    {
      label: "Sales Lead Date",
      value: dataToPreview?.enquiryDate
        ? new Date(dataToPreview.enquiryDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Sales Order Number", value: dataToPreview?.orderConfirmationNumber },
    {
      label: "Sales Order Date",
      value: dataToPreview?.orderConfirmationDate
        ? new Date(dataToPreview.orderConfirmationDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Exp. Delivery Date", value: dataToPreview?.deliveryDate ? new Date(dataToPreview.deliveryDate).toLocaleDateString("en-GB") : null },
    {
      label: "Submission Deadline",
      value: (() => {
        const raw = dataToPreview?.submissionDeadline || (dataToPreview?.rfqDetails ? (typeof dataToPreview.rfqDetails === 'object' ? dataToPreview.rfqDetails.submissionDeadline : isValidJSON(dataToPreview.rfqDetails)?.submissionDeadline) : null);
        if (!raw) return null;
        const d = new Date(raw);
        return isNaN(d.getTime()) ? raw : d.toLocaleDateString("en-GB");
      })(),
    },
    { label: "POC Name", value: dataToPreview?.POCName },
    { label: "POC Number", value: dataToPreview?.POCNumber },
    { label: "Proforma Invoice Number", value: dataToPreview?.performaInvoiceNumber },
    {
      label: "Proforma Invoice Date",
      value: dataToPreview?.performaInvoiceDate
        ? new Date(dataToPreview.performaInvoiceDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Payment Term", value: dataToPreview?.paymentTerm },
    {
      label: "Payment Date",
      value: dataToPreview?.paymentDate
        ? new Date(dataToPreview.paymentDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Delivery Challan Number", value: dataToPreview?.challan_number },
    {
      label: "Delivery Challan Date",
      value: dataToPreview?.challan_date
        ? new Date(dataToPreview.challan_date).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Transporter Name", value: dataToPreview?.transporterName },
    { label: "Transporter GST No", value: dataToPreview?.TGNumber },
    { label: "Vehicle Number", value: dataToPreview?.VehicleNumber },
    { label: "Invoice Number", value: dataToPreview?.invoiceNumber },
    {
      label: "Invoice Date",
      value: dataToPreview?.invoiceDate
        ? new Date(dataToPreview.invoiceDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Kind Attention", value: dataToPreview?.Attention },
    { label: "Service Order Number", value: dataToPreview?.serviceOrderNumber },
    {
      label: "Service Order Date",
      value: dataToPreview?.serviceOrderDate
        ? new Date(dataToPreview.serviceOrderDate).toLocaleDateString("en-GB")
        : null,
    },
    { label: "Service Confirmation Number", value: dataToPreview?.ServiceConfirmationNumber },
    {
      label: "Service Confirmation Date",
      value: dataToPreview?.ServiceConfirmationDate
        ? new Date(dataToPreview.ServiceConfirmationDate).toLocaleDateString("en-GB")
        : null,
    },
    {
      label: "Purpose",
      value: dataToPreview?.purpose
    },
    {
      label: "Ack Number",
      value: dataToPreview?.ackNumber
    },
    {
      label: "Ack Date",
      value: dataToPreview?.ackDate
    },
    { label: "E-Way Bill Number", value: dataToPreview?.ewayBillNumber },
    { label: "E-Way Bill Date", value: dataToPreview?.ewayBillDate },
    { label: "E-Way Bill Valid till", value: dataToPreview?.ewayBillValidTill },
  ]
}

